"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrackDimensions = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _progressTrackerContext = _interopRequireDefault(require("./progress-tracker-context"));

var _token = require("./../_utils/token");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var trackStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _dirRtl, _2, _lastChild;

  var direction = _ref.direction,
      lengthInPx = _ref.lengthInPx,
      widthInPx = _ref.widthInPx,
      neutral = _ref.neutral;
  var row = direction === "row";
  return (0, _emotion.css)({
    display: "flex",
    flexDirection: row ? "row" : "column",
    alignItems: "center",
    width: row ? lengthInPx : undefined,
    height: row ? undefined : lengthInPx,
    "& > *": (_2 = {}, (0, _defineProperty2["default"])(_2, row ? "marginLeft" : "marginTop", widthInPx), (0, _defineProperty2["default"])(_2, "[dir=\"rtl\"] &", (_dirRtl = {}, (0, _defineProperty2["default"])(_dirRtl, row && "marginRight", widthInPx), (0, _defineProperty2["default"])(_dirRtl, row && "marginLeft", 0), _dirRtl)), _2),
    "& > *:last-child": (_lastChild = {}, (0, _defineProperty2["default"])(_lastChild, row ? "marginRight" : "marginBottom", widthInPx), (0, _defineProperty2["default"])(_lastChild, "[dir=\"rtl\"] &", (0, _defineProperty2["default"])({}, row ? "marginLeft" : "marginBottom", widthInPx)), _lastChild),
    "& [mdn-progress-tracker-dash]": {
      borderRadius: 999,
      backgroundColor: t("trackBackgroundColor", neutral ? "neutral" : "theme"),
      flex: "auto",
      width: row ? undefined : widthInPx,
      height: row ? widthInPx : undefined
    },
    "& [mdn-progress-tracker-dot]": {
      borderRadius: 999,
      backgroundColor: t("trackBackgroundColorNeutral"),
      height: widthInPx,
      width: widthInPx
    }
  });
}, ["direction", "lengthInPx", "widthInPx", "neutral"]);
var getTrackDimensions = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var length = _ref2.length,
      size = _ref2.size;
  var lengthInDots = 2 * Math.round(length / 2);
  var widthInPx = t("trackWidth", size);
  return {
    lengthInDots: lengthInDots,
    lengthInPx: lengthInDots * (widthInPx * 2) + widthInPx,
    widthInPx: widthInPx
  };
}, ["length", "size"]);
exports.getTrackDimensions = getTrackDimensions;

function Track(props) {
  var _useContext = (0, _react.useContext)(_progressTrackerContext["default"]),
      t = _useContext.t;

  var _getTrackDimensions = getTrackDimensions(t, props),
      lengthInDots = _getTrackDimensions.lengthInDots,
      lengthInPx = _getTrackDimensions.lengthInPx,
      widthInPx = _getTrackDimensions.widthInPx;

  var displayDash = props.type === "past" || props.type === "present";
  var displayDots = props.type === "present" ? lengthInDots / 2 : props.type === "future" ? lengthInDots : 0;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: trackStyles(t, {
      direction: props.direction,
      lengthInPx: lengthInPx,
      widthInPx: widthInPx,
      neutral: props.neutral
    })
  }, displayDash ? /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-progress-tracker-dash": ""
  }) : null, displayDots > 0 ? Array.apply(null, {
    length: displayDots
  }).map(function (_, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "mdn-progress-tracker-dot": "",
      key: index
    });
  }) : null);
}

Track.propTypes = process.env.NODE_ENV !== "production" ? {
  direction: _propTypes["default"].oneOf(["row", "column"]),

  /**
   * Use this to adjust the step's track length. Note that this is not a pixel
   * value, this is the number of "dots" that make up the track. This must be an
   * even number.
   */
  length: _propTypes["default"].number,
  neutral: _propTypes["default"].bool,

  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["small", "large"]),
  type: _propTypes["default"].oneOf(["past", "present", "future"])
} : {};
var _default = Track;
exports["default"] = _default;